export default "__VITE_ASSET__CFHCQUOI__"